








import { Component, Vue } from "vue-property-decorator";
import Avisos from "@/components/Servicios/Avisos.vue";

@Component({
  components: {
    Avisos
  },
  meta: {
    // sets document title
    title: "Avisos Municipales - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Revisa aquí los Avisos disponibles para ti."
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class AvisosView extends Vue {
  private mounted() {
    document.title =
      "Avisos Municipales - Ilustre Municipalidad de Punta Arenas";
  }
}
